import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ActionButtons, SectionHeader } from '../../common/components';
import {
  AccommodationDetails,
  saveAccommodationAsync,
} from './accommodationsSlice';
import { useAppDispatch } from '../../app/hooks';

function AddAccommodation() {
  const backLinkUrl = '/accommodations/search';
  const dispatch = useAppDispatch();

  const initialAccommodationState: AccommodationDetails = {
    id: '',
    accommodationNumber: 0,
    beds: 0,
    extraBeds: 0,
    novelty: null,
    translations: [],
    internalQualityRating: '',
    onSale: null,
    showInOwnerPage: null,
    qualityRating: 0,
    notOnSaleDays: 0,
    agentNumber: 0,
    visibleOnFi: null,
    visibleOnEn: null,
    visibleOnRu: null,
    keyBox: null,
    countryId: '',
    regionId: '',
    municipalityId: '',
    internalNotes: [],
    publicNotes: [],
    accommodationGroupData: {
      id: '',
    },
    accommodationAttributes: [],
    accommodationAccountRoleCollection: [],
    fireSafety: false,
    geoCode: {
      latitude: null,
      longitude: null,
    },
    optiWatti: false,

    addOns: [],
    addressId: null,
    placeId: null,
    skiResortId: null,
    leviItem: false,
    interhomeService: false,
    lastMinuteOffer: false,
    sportumId: '',
    accounts: [],
    useGredi: false,
    isCapacityProduct: false,
  };
  const history = useNavigate();
  const [accommodation, setAccommodation] = useState(initialAccommodationState);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setAccommodation({ ...accommodation, [name]: value });
  };

  const addAccommodation = () => {
    dispatch(saveAccommodationAsync(accommodation)).then(res => {
      history(`/accommodations/details/${res.payload}`, {
        state: {
          backUrl: `/accommodations/search`,
        },
      });
    });
    setSubmitted(true);
  };

  const initFetch = useCallback(() => {
    addAccommodation();
  }, [dispatch]);

  useEffect(() => {
    initFetch();
  }, [initFetch]);

  return (
    <>
      <Helmet>
        <title>Majoitukset - Uusi majoitus</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Majoitukset ja Ryhmät', 'Majoitukset']}
          Title="Uusi majoitus"
        />
        <Container className="container-form mt-48">
          {submitted ? (
            <Alert variant="success">Tiedot tallennettu!</Alert>
          ) : (
            <Form>
              <Form.Group className="mb-40">
                <Form.Label
                  className="required"
                  htmlFor="accommodationNumberTitle"
                >
                  Majoituksen tunniste
                </Form.Label>
                <Form.Control
                  autoComplete="off"
                  type="number"
                  id="accommodationNumberTitle"
                  required
                  value={accommodation.accommodationNumber || ''}
                  onChange={handleInputChange}
                  name="accommodationNumber"
                />
              </Form.Group>

              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={addAccommodation}
              />
            </Form>
          )}
        </Container>
      </Container>
    </>
  );
}

export default AddAccommodation;
